import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

export default function MeetingRoom() {
  const { meetingId } = useParams();
  const containerRef = useRef(null);

  useEffect(() => {
    if (!meetingId || !containerRef.current) return;

    const domain = "meet.jit.si";

    const api = new window.JitsiMeetExternalAPI(domain, {
      roomName: meetingId,
      parentNode: containerRef.current,
      width: "100%",
      height: "100%",
      configOverwrite: {
        startWithAudioMuted: true,
      },
      interfaceConfigOverwrite: {
        DISABLE_JOIN_LEAVE_NOTIFICATIONS: false,
      },
      userInfo: {
        displayName: "Guest User"
      }
    });
    return () => api.dispose();
  }, [meetingId]);

  return (
    <div
      ref={containerRef}
      style={{ width: "100%", height: "100vh", background: "#000" }}
    />
  );
}